import { axios } from 'lib/axios';
import { useQuery } from 'react-query';

export const getActiveCustomers = ({ pageNumber }) => {
  return axios.get(`/customer/active/${pageNumber}`);
};

export const useActiveCustomers = ({ pageNumber, config }) => {
  return useQuery({
    ...config,
    queryKey: ['activeUsers', pageNumber],
    queryFn: () => getActiveCustomers({ pageNumber }),
  });
};
